import {
  UPDATE_ACTIVE_USER,
  FETCH_CURRENT_BOOKING,
  UPDATE_BOOKING_STEP,
  UPDATE_BOOKING_USERS,
  UPDATE_BOOKING_SUGGESTED_USERS,
  UPDATE_ACTIVE_ROOT_CATE,
  UPDATE_ACTIVE_SUB_CATE,
  UPDATE_AVAILABLE_STYLISTS,
  UPDATE_STYLIST_SETTINGS,
  UPDATE_STYLIST_AVAILABLE_TIMES,
  UPDATE_BOOKING_NOTES,
  UPDATE_BOOKING_CREDIT_CARD,
  UPDATE_ACTIVE_ROOT_CATE_MOBILE,
  UPDATE_BOOKING_HISTORY,
  UPDATE_STYLIST_MAPPINGS,
  UPDATE_NEW_USER_FLAG,
} from '../constants';
import { User } from '../types/user';
import { FetchBookingOptions } from '../types/salon';
import { Stylist, FetchStylistOptions, FetchDatesOptions, FetchTimesOptions } from '../types/stylist';
import BookingService from '../services/bookingService';
import { BookingItem } from '../types/booking';

export const bookingActions = {
  storeActiveRootCateMobile(payload: string) {
    return {
      type: UPDATE_ACTIVE_ROOT_CATE_MOBILE,
      payload,
    };
  },

  storeActiveRootCate(payload: string) {
    return {
      type: UPDATE_ACTIVE_ROOT_CATE,
      payload,
    };
  },

  storeActiveSubCate(payload: string) {
    return {
      type: UPDATE_ACTIVE_SUB_CATE,
      payload,
    };
  },

  fetchBookingHistory(salonId: number, phoneNumber: string) {
    return (dispatch, getState, { http }) => {
      return BookingService(http).fetchBookingHistory(salonId, phoneNumber);
    };
  },

  storeBookingHistory(payload: Record<string, BookingItem[]>) {
    return {
      type: UPDATE_BOOKING_HISTORY,
      payload,
    };
  },

  updateStep(payload: number) {
    return {
      type: UPDATE_BOOKING_STEP,
      payload,
    };
  },

  storeNewUserFlag(payload: number) {
    return {
      type: UPDATE_NEW_USER_FLAG,
      payload,
    };
  },

  storeActiveUser(payload: number) {
    return {
      type: UPDATE_ACTIVE_USER,
      payload,
    };
  },

  updateUsers(payload: User[]) {
    return {
      type: UPDATE_BOOKING_USERS,
      payload,
    };
  },

  updateSuggestedUsers(payload) {
    return {
      type: UPDATE_BOOKING_SUGGESTED_USERS,
      payload,
    };
  },

  fetchSettings(salonId: number | string) {
    return (dispatch, getState, { http }) => {
      return BookingService(http).fetchSettings(salonId);
    };
  },

  fetchUserProfile(options) {
    return (dispatch, getState, { http }) => {
      return BookingService(http).fetchUserProfile(options);
    };
  },

  fetchUsersByPhone(options) {
    return (dispatch, getState, { http }) => {
      return BookingService(http).fetchUsers(options);
    };
  },

  storeStylists(payload: Stylist[]) {
    return {
      type: UPDATE_AVAILABLE_STYLISTS,
      payload,
    };
  },

  storeMappedStylists(payload: Record<number, Stylist[]>) {
    return {
      type: UPDATE_STYLIST_MAPPINGS,
      payload,
    };
  },

  fetchStylists(options: FetchStylistOptions, services = []) {
    return (dispatch, getState, { http }) => {
      return BookingService(http).fetchStylists(options, services);
    };
  },

  storeStylistSettings(payload: any) {
    return {
      type: UPDATE_STYLIST_SETTINGS,
      payload,
    };
  },

  fetchStylistSettings(options: FetchDatesOptions, services = []) {
    return (dispatch, getState, { http }) => {
      return BookingService(http).fetchStylistSettings(options, services);
    };
  },

  storeAvailableTimes(payload: any) {
    return {
      type: UPDATE_STYLIST_AVAILABLE_TIMES,
      payload,
    };
  },

  fetchAvailableTimes(options: FetchTimesOptions, services = []) {
    return (dispatch, getState, { http }) => {
      return BookingService(http).fetchAvailableTimes(options, services);
    };
  },

  storeBookingNotes(payload: string) {
    return {
      type: UPDATE_BOOKING_NOTES,
      payload,
    };
  },

  storeCreditCard(payload: any) {
    return {
      type: UPDATE_BOOKING_CREDIT_CARD,
      payload,
    };
  },

  createBooking(data) {
    return (dispatch, getState, { http }) => {
      return BookingService(http).createBooking(data);
    };
  },

  updateBooking(data: any, accessToken: string) {
    return (dispatch, getState, { http }) => {
      return BookingService(http).updateBooking(data, accessToken);
    };
  },

  storeCurrentBooking(payload: any) {
    return {
      type: FETCH_CURRENT_BOOKING,
      payload,
    };
  },

  fetchBookingById(options: FetchBookingOptions) {
    return (dispatch, getState, { http }) => {
      return BookingService(http).fetchBookingById(options);
    };
  }
};
